__turbopack_context__.v({
  "accent-text": "fKTpLG_accent-text",
});
